import * as React from 'react';

import { Input } from './input';
import { EyeIcon, EyeOffIcon } from 'lucide-react';

export interface PasswordInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const PasswordInput = React.forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ className, type, ...props }, ref) => {
    const [showPassword, setShowPassword] = React.useState(false);
    return (
      <Input
        type={showPassword ? 'text' : 'password'}
        className={className}
        endAdornment={
          showPassword ? (
            <EyeIcon
              className="select-none cursor-pointer"
              onClick={() => setShowPassword(false)}
            />
          ) : (
            <EyeOffIcon
              className="select-none cursor-pointer"
              onClick={() => setShowPassword(true)}
            />
          )
        }
        placeholder="Enter your password"
        ref={ref}
        {...props}
      />
    );
  }
);
PasswordInput.displayName = 'PasswordInput';

export { PasswordInput };
